<template>
  <div id="contenedor-mapa-actores">
    <div class="contenedor-titulo">
      <p class="titulo">
        Comunidad involucrada en adaptación y mitigación de sargazo en México.
      </p>

      <SelectoresMapa />
    </div>

    <DaiTarjetaContenedorMapa
      class="dai-mapa-actores"
      :class="{
        'lista-actores-visible': listaActoresVisible,
        'footer-colapsado': footerColapsado,
      }"
    >
      <template #header>
        <RadiosLineasEstrategicas />

        <!--DaiLeyendaMapa
          class="leyenda-actores"
          titulo="Número de personas por ubicación"
          :para="
            require('@/components/mapas/capas/PuntosActores').default.data()
              .idCapa
          "
          :tamanosDeMapa="true"
        /-->
      </template>

      <DaiMapa
        ref="mapaActores"
        :extension="extensionMapa"
        @reset_view="resetearTodoMapa"
      >
        <DaiCapaXyz :z-index="1" />
        <PaisesActores />
        <EstadosActores />
        <GalletaActores />
      </DaiMapa>

      <template #footer>
        <ListadoActores />

        <button
          class="boton-para-colapsar-footer"
          @click="footerColapsado = !footerColapsado"
        >
          {{ footerColapsado ? "Más información" : "Menos información" }}
        </button>
      </template>
    </DaiTarjetaContenedorMapa>
  </div>
</template>

<script>
import "@/components/mapas/mapaActores.scss";
import { mapState, mapMutations } from "vuex";
import SelectoresMapa from "@/components/mapas/SelectoresMapa";
import RadiosLineasEstrategicas from "@/components/mapas/RadiosLineasEstrategicas";
import ListadoActores from "@/components/mapas/ListadoActores";

// capas
import PaisesActores from "@/components/mapas/capas/PaisesActores";
import EstadosActores from "@/components/mapas/capas/EstadosActores";
import GalletaActores from "@/components/mapas/capas/GalletaActores";

export default {
  data: () => ({
    footerColapsado: true,
    mapaCargado: false,
  }),
  mounted() {
    this.$refs.mapaActores.map.on("moveend", this.moveEndMap);
    setTimeout(() => {
      this.mapaCargado = true;
    }, 4000);
  },
  methods: {
    ...mapMutations("mapaActores", [
      "resetearTodoMapa",
      "cambiarListaActoresVisible",
    ]),
    moveEndMap() {
      // Si el usuario mueve el mapa una vez el estado la lista de actores cambia
      if (this.mapaCargado) {
        this.cambiarListaActoresVisible(true);
        this.quitarMoveEndMap();
      }
    },
    quitarMoveEndMap() {
      this.$refs.mapaActores.map.un("moveend", this.moveEndMap);
    },
  },
  watch: {
    listaActoresVisible() {
      this.$refs.mapaActores.forceResizeMap();
    },
    extensionMapa() {
      setTimeout(() => {
        this.$refs.mapaActores.external_force_reset_view();
      }, 500);
    },
  },
  computed: {
    ...mapState("mapaActores", ["listaActoresVisible", "extensionMapa"]),
  },
  beforeDestroy() {
    this.quitarMoveEndMap();
  },
  components: {
    SelectoresMapa,
    RadiosLineasEstrategicas,
    ListadoActores,

    // capas
    PaisesActores,
    EstadosActores,
    GalletaActores,
  },
};
</script>
